module.exports = __webpack_public_path__ + "img/linkus-top.5d56eb57.png";